import React, { FC, useEffect } from 'react';
import s from './TopMenu.module.scss';
import { ReactComponent as NotificationIcon } from 'images/notification-gray.svg';
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-go-back.svg';

import { ReactComponent as Bag } from 'images/dark-green-cart.svg';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';

type Props = {
  openBasket: () => void;
  title: string;
  icon: 'notification' | 'goBack';
};

const TopMenuForShopWithBack: FC<Props> = ({ openBasket, title, icon }) => {
  const navigate = useNavigate();
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);

  useEffect(() => {
    refetchCart();
  }, [userId]);

  interface CartItem {
    count: number;
  }
  const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
  const displayCount: string | number = itemCount > 9 ? '9+' : itemCount;

  return (
    <div className={s.container} style={{ background: 'transparent' }}>
      {icon === 'notification' && (
        <NotificationIcon className={s.container_notification_icon} onClick={() => navigate('/user-notifications')} />
      )}
      {icon === 'goBack' && <GoBackIcon onClick={() => navigate(-1)} />}
      <div className={s.container_right_icons}>
        <div className={s.cart_wrapper} onClick={openBasket}>
          <Bag />
          {itemCount > 0 && <div className={s.counter}>{String(displayCount)}</div>}
        </div>
      </div>
    </div>
  );
};

export default TopMenuForShopWithBack;
